import { Controller } from "@hotwired/stimulus"

// Counts down locally from a server-provided end time, so we don't broadcast
// every second — only start/stop reach the server. Driven by the value-changed
// callback (it also fires on connect) so a morph that swaps ends-at in place
// restarts the countdown.
export default class extends Controller {
  static values = { endsAt: String }
  static targets = ["display"]

  endsAtValueChanged() {
    clearInterval(this.interval)
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const remaining = Math.max(0, Math.round((new Date(this.endsAtValue) - new Date()) / 1000))
    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60
    this.displayTarget.textContent = `${minutes}:${String(seconds).padStart(2, "0")}`

    // Re-applied every tick so a morph (which resyncs the class attribute)
    // can't strip the time's-up pulse.
    this.element.classList.toggle("animate-pulse", remaining <= 0)
    this.element.classList.toggle("bg-wrong", remaining <= 0)
  }
}
